import Vuex from 'vuex';
import Vue from 'vue';
import app from './modules/app';
import nav from './modules/nav';
import twenty from './modules/twenty';
import giftVoucher from './modules/giftVoucher';
import booking from './modules/booking';
import skirental from './modules/ski/rental';
import skipass from './modules/ski/pass';
import skischool from './modules/ski/school';
import triggers from './modules/triggers';
import affiliates from './modules/affiliate';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    app,
    nav,
    twenty,
    giftVoucher,
    booking,
    skirental,
    skipass,
    skischool,
    triggers,
    affiliates,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js